import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Ruler = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g clip-path="url(#clip0_4669_22270)">
      <path
        opacity="0.3"
        d="M19.5455 12.5H17.5455V8.5H15.5455V12.5H13.5455V8.5H11.5455V12.5H9.5455V8.5H7.5455V12.5H5.5455V8.5H3.5455V16.5H21.5455V8.5H19.5455V12.5Z"
      />
      <path d="M21.5455 6.5H3.5455C2.4455 6.5 1.5455 7.4 1.5455 8.5V16.5C1.5455 17.6 2.4455 18.5 3.5455 18.5H21.5455C22.6455 18.5 23.5455 17.6 23.5455 16.5V8.5C23.5455 7.4 22.6455 6.5 21.5455 6.5ZM21.5455 16.5H3.5455V8.5H5.5455V12.5H7.5455V8.5H9.5455V12.5H11.5455V8.5H13.5455V12.5H15.5455V8.5H17.5455V12.5H19.5455V8.5H21.5455V16.5Z" />
    </g>
    <defs>
      <clipPath id="clip0_4669_22270">
        <rect width="24" height="24" transform="translate(0.545502 0.5)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
export default Ruler;



// WEBPACK FOOTER //
// ./src/common/icons/Ruler/index.tsx